import React, { useContext } from 'react';
import styles from './AnalyticsMain.module.scss';
import {
  AppOptionsContext,
  UserContext,
  WorkspaceConfig,
  checkPermissions,
  useSubscription
} from 'ui-smartforce-settings';
import { AGENCY_ANALYTICS_WATCH } from '../../../../Constants/RolesAndPermissions';
import { useParams } from 'react-router-dom';
import { AnalyticsWidgets } from './AnalyticsWidgets/AnalyticsWidgets';

export const AnalyticsMain = (): React.ReactElement<{}> => {
  const { user } = useContext(UserContext);
  const { workspaces } = useContext(AppOptionsContext);
  const subscription = useSubscription('nexus');
  const { workspaceId } = useParams<{ workspaceId: string }>();

  const workspace: WorkspaceConfig | undefined = workspaces.find(
    (w) => w.id === workspaceId
  );

  const hasAnalytics: boolean =
    !!subscription ||
    checkPermissions(AGENCY_ANALYTICS_WATCH, user?.role.permissions);

  return (
    <div className={styles.analyticsMain}>
      {hasAnalytics && workspace && <AnalyticsWidgets workspace={workspace} />}
    </div>
  );
};
